import { AddCircleOutline } from '@mui/icons-material'
import { Box, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CommonPageLayout } from 'src/components/common/CommonPageLayout'
import { IMainComponentType } from 'src/generated-types/main-component-type'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'
import { permissionValue } from '../../../../enums/permissionValue'
import { CertificateTable } from '../../Certificates/Components/CertificateTable'

interface CertificateTabProps {
  onAddCertificateForComponent: () => void
  mainComponentId: EntityId
  mainComponentType?: IMainComponentType
  positionId: EntityId
  customerId: EntityId
  Context?: React.Context<any> | null
  disabledAddButton?: boolean
  hasPendingService?: boolean
  mainComponentStatus: number
}

export default function CertificateTab({
  onAddCertificateForComponent,
  mainComponentId,
  mainComponentType,
  positionId,
  customerId,
  Context = null,
  disabledAddButton,
  hasPendingService,
  mainComponentStatus,
}: CertificateTabProps) {
  const { t } = useTranslation(['certificate', 'common'])
  const theme = useTheme()
  const [disableAddCertificate, setDisableAddCertificate] = useState(false)

  useEffect(() => {
    if (hasPendingService) {
      setDisableAddCertificate(hasPendingService)
    }
  }, [hasPendingService])

  return (
    <CommonPageLayout
      titleSection={{ subtitle: t('certificates', { ns: 'certificate' }) }}
      topAction={[
        {
          buttonText: t('add-certificate', { ns: 'certificate' }),
          buttonIcon: <AddCircleOutline />,
          onClick: onAddCertificateForComponent,
          permissionBinaryValues: [
            permissionValue.Locality.MainComponent.Certificate.Write,
            permissionValue.ClientAdminPermission,
            permissionValue.ServiceStation.Write,
          ],
          variant: 'outlined',
          shadowWeight: null,
          context: Context,
          disabled: disabledAddButton != undefined ? disabledAddButton : disableAddCertificate,
        },
      ]}
      titleContainerProps={{ paddingBottom: '12px' }}
    >
      <Box padding={'8px'} bgcolor={getThemeColor(theme, MUIThemeColors.white)} borderRadius={'4px'}>
        <CertificateTable
          mainComponentId={mainComponentId!}
          mainComponentType={mainComponentType}
          positionId={positionId}
          customerId={customerId}
          certificatesParams={{}}
          height={window.innerHeight / 3}
          context={Context}
          setDisableAddCertificate={
            hasPendingService === null || hasPendingService === undefined ? setDisableAddCertificate : undefined
          }
          mainComponentStatus={mainComponentStatus}
        />
      </Box>
    </CommonPageLayout>
  )
}
